import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {AuthService} from '../services/auth.service';
import {LocalisationService} from '../services/localisation.service';
import {UsersService} from '../services/users.service';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
    constructor(
        private readonly authService: AuthService,
        private readonly usersService: UsersService,
        private readonly localisationService: LocalisationService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = req.headers.set('Content-Type', 'application/json');

        if (this.usersService.userProfile) {
            if (this.usersService.userProfile.locale) {
                headers = headers.set('Accept-Language', this.usersService.userProfile.locale);
            } else {
                headers = headers.set('Accept-Language', this.localisationService.language);
            }
        } else {
            headers = headers.set('Accept-Language', this.localisationService.language);
        }


        if (
            this.authService.getStorageItem('master_sub_profile_logged_token')
            && this.authService.getStorageItem('master_sub_profile_logged_token').length > 0
            && window.location.href.includes('master/meals')
        ) {
            if (req.url.includes('master/user/profile') || req.url.includes('master/profiles/single/')) {
                headers = headers.set('Authorization', `Token ${this.authService.getStorageItem('original_logged_token')}`);

            } else {
                headers = headers.set('Authorization', `Token ${this.authService.getStorageItem('master_sub_profile_logged_token')}`);
            }
        } else {
            if (this.authService.token) {
                headers = headers.set('Authorization', `Token ${this.authService.token}`);
            }
        }

        headers = headers.set('cache-control', `no-cache, no-store, must-revalidate`);
        headers = headers.set('pragma', `no-cache`);
        headers = headers.set('expires', `0`);

        let authReq = req.clone({headers});

        if (req.url.includes('master/user/profile')) {
            authReq = authReq.clone({url: req.url.replace('master/', '')});

            // console.log(authReq);
        }

        if (authReq.body instanceof FormData) {
            authReq = authReq.clone({ headers: authReq.headers.delete('Content-Type', 'application/json') });
            authReq = authReq.clone({ headers: authReq.headers.delete('Accept', 'application/json')});
            // authReq = authReq.clone({ headers: authReq.headers.append('Content-Type', 'undefined')});
        }

        return next.handle(authReq).pipe(
            map(event => {
                if (event instanceof HttpErrorResponse) {
                    if (event.status === 401) {
                        this.authService.errorHandler();
                    }
                }

                return event;
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    this.authService.errorHandler();
                }

                throw err;
            })
        );
    }
}
